import _ from "lodash";
import {
  ExpectedVolumesChanges,
  ModifiedVolumeForChange,
} from "./ChangesCollector";

export const removeNullValues = (object: Object) =>
  Object.fromEntries(Object.entries(object).filter(([_, v]) => v != null));

export const addDefinedVolumeChangeValues = (
  incomingChanges: ModifiedVolumeForChange
) => {
  const updateObject = {
    customerId: incomingChanges.customerNo,
    volumeAgreed: incomingChanges.volumeAgreed,
  };
  for (const [key, value] of Object.entries(
    removeNullValues(_.omit(incomingChanges, "customerNo", "volumeAgreed"))
  )) {
    _.set(updateObject, key, { value });
  }
  return updateObject;
};

export const transformChangesToInput = (
  negotiationYear: number,
  customerStatisticalGrouping: string,
  changes: Array<ExpectedVolumesChanges>
) => ({
  negotiationYear,
  customerStatisticalGrouping: Number(customerStatisticalGrouping),
  changesPerRoute: changes.map((c) => ({
    routePairId: c.routePairId,
    changesForCustomer: c.modifiedVolumes.map((v) =>
      addDefinedVolumeChangeValues(v)
    ),
  })),
});
